<script lang="ts">
  import type { ModalSection } from '~/types';

  type Props = {
    sections: ModalSection[];
  };
  const props: Props = $props();
</script>

<ul class="directory">
  {#each props.sections as section}
    <li>
      <a data-sveltekit-replacestate href="#{section.id}">
        <section.icon />
        {section.desc}
      </a>
    </li>
  {/each}
</ul>

<style lang="scss">
  @use '~/theme/include-media' as *;
  .directory {
    width: fit-content;
    margin: 0 auto;
    list-style-type: none;
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem 0;
    li {
      margin: 0;
    }
    :global(svg) {
      width: 20px;
      height: 20px;
    }
    a {
      color: currentColor;
      text-decoration: underline;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-size: 1.125rem;
    }
  }
</style>
